var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 60,
    viewBox: "0 0 52 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1058_3159)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 60,
    rx: 8,
    fill: "#DCEAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.7305,
    y: 32,
    width: 71.6763,
    height: 71.6763,
    rx: 5,
    transform: "rotate(36.5953 11.7305 32)",
    fill: "#95B6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.9414,
    y: 23,
    width: 66.2615,
    height: 66.2615,
    rx: 6,
    transform: "rotate(36.5953 35.9414 23)",
    fill: "#2559F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 17,
    r: 5,
    fill: "#2559F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1058_3159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 60,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileUpload);
export default __webpack_public_path__ + "static/media/icon-file_upload.e9ad3ca6677027bdc32628877a0cd731.svg";
export { ForwardRef as ReactComponent };